import React, { useEffect, useState } from 'react';  
import { Modal, Button, Input } from 'antd';  
import {
  MultiSwitch,
} from 'src/DigitalProtocolModule/components';
import './index.scss'


interface VisitWindowModal {
  windowUnit: string,
  visitWindowOpen: Digital_Protocol_SoA_Table_Data.OpenVisitWindowType
  handleCancel: () => void
  handleSubmit: () => void
  weekVisitWindow: Digital_Protocol_SoA_Table_Data.VisitWindowType
}
  
export function VisitWindowModal({
  windowUnit,
  visitWindowOpen,
  handleCancel,
  handleSubmit,
  weekVisitWindow
}) {  
  const {visit, visible } = visitWindowOpen
  const [unitIndex, setUnitIndex] = useState<string>('-/+')
  const [upperLowervalues, setUpperLowerValues] = useState<{ [key: string]: any }>({
      lower_visit_value: '',
      upper_visit_value :  '',
      visit_window_type_id :  '',
  });
  
  const stopPropagation = (e) => {  
    e.stopPropagation();  
  };

  useEffect(() => {}, [upperLowervalues])

  const windowChangeHandler = (val: any, type: number, unit: string) => {                
    const regex = /^\d*$/; // Allow empty string and positive integers   
  
    let newVal: any;  
    let numericValue: number | null = null;  

    if (regex.test(val)) {  
      numericValue = val === '' ? null : parseInt(val, 10);        
    }  
    
    if (numericValue !== null && ((windowUnit === 'Week' && (numericValue > 1000 || numericValue < -1000)) || (windowUnit === 'Day' && (numericValue > 7000 || numericValue < -7000)))) {  
      return;  
    }  

    if (type === 1) {  
      if (numericValue !== null) {  
          setUpperLowerValues(() => ({  
              visit_window_type_id: type,  
              lower_visit_value: -numericValue,  
              upper_visit_value: numericValue,  
          }));  
      }  else{
        resetState();
      }
      return;  
  } else
    if (type === 2) { 
      let lowerValue = upperLowervalues.lower_visit_value;  
      let upperValue = upperLowervalues.upper_visit_value;  
    
      if (unit === 'lower_visit_value') {  
        lowerValue = numericValue !== null ? -numericValue : '';  
      } else if (unit === 'upper_visit_value') {  
        upperValue = numericValue !== null ? numericValue : '';  
      }  
      
      setUpperLowerValues({  
        visit_window_type_id: type,  
        lower_visit_value: lowerValue,  
        upper_visit_value: upperValue,  
      });      
      return;     
    } else if (type === 3) {     
      newVal = numericValue !== null ? -numericValue : '';  
      setUpperLowerValues(() => ({  
        visit_window_type_id: type,  
        [unit]: newVal,  
        upper_visit_value: null
      }));  
      return;          
    } else if (type === 4) {     
      newVal = numericValue !== null ? numericValue : '';  
      setUpperLowerValues(() => ({  
        visit_window_type_id: type,  
        lower_visit_value: null,
        [unit]: newVal,          
      }));  
      return;          
    }   
    newVal = numericValue !== null ? numericValue : ''; 
    setUpperLowerValues(() => ({  
      visit_window_type_id: type,  
      [unit]: newVal,  
    }));    
  }; 

  const resetState = () => {  
    setUpperLowerValues({  
      lower_visit_value: null,  
      upper_visit_value: null,  
      visit_window_type_id: null,  
    });  
  };  

  useEffect(() => {
    let type = weekVisitWindow?.visit_window_type_id;
    switch(type) {
      case 1:
        setUnitIndex('-/+');
        break;
      case 2:
        setUnitIndex('-,+');
        break;
      case 3:
        setUnitIndex('- only');
        break;
      case 4:
        setUnitIndex('+ only');
        break;
      default:
        break;
    }
    setUpperLowerValues(weekVisitWindow)
  }, [weekVisitWindow])

  const renderInputs = () => {  
    if(!upperLowervalues) return ;
    const {
      upper_visit_value,
      lower_visit_value,
      visit_window_type_id
    } = upperLowervalues;
    switch (unitIndex) {  
      case '-/+':  
        return <Input placeholder="+/- 0" value={visit_window_type_id === 1 ? Math.abs(upper_visit_value) : ''} onChange={(e) => windowChangeHandler(e.target.value, 1, 'upper_visit_value')} />;  
      case '-,+':  
        return (  
          <>  
            <Input  
              placeholder="- 0"  
              value={visit_window_type_id === 2 ? (typeof lower_visit_value === "number" ? Math.abs(lower_visit_value) : '') : ''}  
              onChange={(e) => windowChangeHandler(e.target.value, 2, 'lower_visit_value')} 
            /> 
            <Input  
              placeholder="+ 0"  
              value={visit_window_type_id === 2 ? upper_visit_value : ''} 
              style={{ marginBottom: 8 }} 
              onChange={(e) => windowChangeHandler(e.target.value, 2, 'upper_visit_value') } 
            /> 
          </>  
        ); 
      case '- only':
        return <Input placeholder="- only" value={visit_window_type_id === 3 ? (typeof lower_visit_value === "number" ? Math.abs(lower_visit_value) : '') : ''} onChange={(e) => windowChangeHandler(e.target.value, 3, 'lower_visit_value')} />;  
      case '+ only':
        return <Input placeholder="+ only" value={visit_window_type_id === 4 ? upper_visit_value : ''} onChange={(e) => windowChangeHandler(e.target.value, 4, 'upper_visit_value')} />;  
      default:  
        break;
    }  
  }; 

  return (  
    <>  
      <Modal  
        className="visit-window-soa"
        title={`Visit Window (${windowUnit})`}
        visible={visible}  
        onCancel={handleCancel}  
        footer={[  
          <Button key="cancel" onClick={handleCancel}>  
            Cancel  
          </Button>,  
          <Button key="submit" type="primary" onClick={() => handleSubmit(upperLowervalues, visit)}>  
            Submit  
          </Button>,  
        ]}  
      >  
        <div style={{ marginBottom: 16 }} onClick={stopPropagation}>  
          <MultiSwitch  
            options={['-/+', '-,+', '- only', '+ only']}  
            value={unitIndex} 
            onChange={(i) => setUnitIndex(i.toString())} />  
        </div>  
        <div>  
            {renderInputs()}  
        </div>  
      </Modal>  
    </>  
  );  
};    
